import {
  FilterValueComplex,
  FilterQueryParamOperator,
  BaseFilter,
  FilterControlType,
} from '../filter.types';
import { BaseFilterClass } from '../BaseFilterClass';
import { Observable, of } from 'rxjs';

export class FileNameFilter
  extends BaseFilterClass
  implements BaseFilter<FilterValueComplex[]>
{
  constructor({
    urlQueryParam = 'file_name',
    urlQueryParamOperator = FilterQueryParamOperator.OperatorLike,
    quickSearchLabel = 'File Name',
    quickSearchPrefixes = ['File Name', 'file', 'name'],
    quickSearchAutocompleteExclusionRegExp = /^\w/i,
    htmlLabel = 'File Name',
    htmlElementId = 'file_name',
    placeholder = 'Search for a File Name',
    filterControlType = FilterControlType.FilterControlTypeString,
  } = {}) {
    super();

    this.setURLQueryParam(urlQueryParam);
    this.setURLQueryParamOperator(urlQueryParamOperator);
    this.setQuickSearchLabel(quickSearchLabel);
    this.setQuickSearchPrefixes(quickSearchPrefixes);
    this.setQuickSearchAutocompleteRegExp(
      quickSearchAutocompleteExclusionRegExp
    );
    this.setHTMLLabel(htmlLabel);
    this.setHTMLElementId(htmlElementId);
    this.setPlaceholder(placeholder);
    this.setFilterControlType(filterControlType);
  }

  override loadFilterData(): Observable<FilterValueComplex[]> {
    return of<FilterValueComplex[]>([]);
  }
}
